/**
 * Layout output component
 * 
 */

import React, { PureComponent } from 'react';

export default class Output extends PureComponent {

	constructor(props) {
		
		super(props);
		
		this.state = {

			classes: null,
		}
    }

	render() {
		
		const classes = this.state.classes ? 'layout-output ' + this.state.classes : 'layout-output';

		return <div className={classes} id="layout-output"></div>;
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/output/output.js